module.exports = __webpack_public_path__ + "img/Button_PlayForFreeOver.14e5ac0f.png";